import { useMemo } from 'react';

import { cn } from '@utils';

interface SkeletonFormProps {
  customStyles?: boolean;
  className?: string;
  type?: SkeltonType;
}

export enum SkeltonType {
  Text,
  Avatar,
  Button,
}

export const Skeleton = ({
  customStyles = false,
  type = SkeltonType.Text,
  className = type === SkeltonType.Text ? 'w-1/3 h-3' : '',
}: SkeletonFormProps) => {
  const isButton = type === SkeltonType.Button;
  const isAvatar = type === SkeltonType.Avatar;
  const dynamicClasses = useMemo(
    () =>
      cn(
        'bg-gray-300 animate-pulse',
        !customStyles && 'rounded',
        isButton && !customStyles && 'h-8 bg-gray-300 rounded-2xl flex flex-1',
        isAvatar && !customStyles && 'h-8 w-8 rounded-full',
        className,
      ),
    [className, customStyles, isAvatar, isButton],
  );

  return <div className={dynamicClasses} />;
};
